import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";
import {
  Alert,
  Container,
  Button,
  Row,
  Col,
  Form,
  FormControl
} from "react-bootstrap";

import { logout } from "../login/LoginActions";

import brontoBanner from "../../images/4_banner_verticalname_small_bronto.png";
import CustomNavbar from "../navbar/Navbar";

import motemonCopyright from "../../images/7_motemon_copyright.png";

class ResetPassword extends Component {
  onLogout = () => {
    this.props.logout();
  };
  
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: "",
      status: ""
    };
  }

  onChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: name === "email" ? value.toLowerCase() : value });
  };

  onSendClick = () => {
    this.setState({ emailError: "" });
    this.setState({ status: "" });

    var local_custom_language = localStorage.getItem('custom_language');

    const userData = {
      email: this.state.email,
      custom_language : local_custom_language
    };
    axios
      .post("/api/v1/users/reset_password/", userData)
      .then(response => {
        this.setState({ status: "success" });
      })
      .catch(error => {
        if (error.response && error.response.data.hasOwnProperty("email")) {
          this.setState({ emailError: error.response.data["email"] });
        } else {
          this.setState({ status: "error" });
        }
      });
  };

  render() {
    const { auth } = this.props;
    const user = auth?.user || {};
    const isLoggedIn = user.username?.trim().length > 0 ? true : false;
    
    let errorAlert = (
      <Alert variant="danger">
        <Alert.Heading>Problema durante envío de correo para resetear tu password</Alert.Heading>
        Por favor intente de nuevo o contacta a soporte ( support@brontomarket.com ) para obtener ayuda adicional.
      </Alert>
    );

    let successAlert = (
      <Alert variant="success">
        <Alert.Heading>Email enviado!</Alert.Heading>
        <p>
          Acabamos de enviarte un mensaje con un link para resetear tu password. Por favor revisa tu email.
        </p>
        <p>
          Si no recibes nuestro correo en un par de minutos, por favor intenta de nuevo o contacta a soporte ( support@brontomarket.com )
        </p>
      </Alert>
    );

    let form = (
      <div>
        <Form>
          <Form.Group controlId="emailId">
            <Form.Label>Email</Form.Label>
            <Form.Control
              isInvalid={this.state.emailError}
              type="text"
              name="email"
              placeholder="Ingresa tu email"
              value={this.state.email}
              onChange={this.onChange}
            />
            <FormControl.Feedback type="invalid">
              {this.state.emailError}
            </FormControl.Feedback>
          </Form.Group>
        </Form>
        <Button color="primary" onClick={this.onSendClick}>
          Enviar correo con link para resetear tu password.
        </Button>
      </div>
    );

    let alert = "";
    if (this.state.status === "error") {
      alert = errorAlert;
    } else if (this.state.status === "success") {
      alert = successAlert;
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", alignItems: "center" }}>
        <CustomNavbar isLoggedIn={isLoggedIn} user={user} onLogout={this.onLogout} />
        <img
          src={brontoBanner}
          alt="BrontoBanner"
          style={{ width: "30%", minWidth: "180px", maxWidth: "333px", height: "auto", margin: "20px 0 20px 0" }}
        />
        <Container>
          <Row>
            <Col md="6">
              <h2>Resetear Password</h2>
              {alert}
              {this.state.status !== "success" && form}
            </Col>
          </Row>
        </Container>
        <footer style={{ textAlign: "center", marginTop: "auto", padding: "1rem 0", marginBottom: "2rem" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={motemonCopyright}
              alt="motemonCopyright"
              style={{ width: "85px", height: "auto", margin: "0" }}
            />
            <p style={{ margin: "0px" }}>2024</p>
          </div>
        </footer>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, {
  logout
})(withRouter(ResetPassword));
